import { Suspense } from 'react'
import { Route } from 'react-router-dom'
import { Spin } from 'antd'

const RouteWithSubRoutes = (route) => {
    return (
        // <Suspense fallback={<Spin size="large" />}>
            <Route 
                path={route.path}
                exact={route.exact}
                render={
                    (props) => <route.component {...props} routes={route.routes} />
                }
                />
        // </Suspense>
    )
}

export default RouteWithSubRoutes